<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45.8 20H14.175L13.075 10H46.925M30 47.5C28.0109 47.5 26.1032 46.7098 24.6967 45.3033C23.2902 43.8968 22.5 41.9891 22.5 40C22.5 35 30 26.5 30 26.5C30 26.5 37.5 35 37.5 40C37.5 41.9891 36.7098 43.8968 35.3033 45.3033C33.8968 46.7098 31.9891 47.5 30 47.5ZM7.5 5L12.5 50.575C12.825 53.075 14.925 55 17.5 55H42.5C45 55 47.175 53.075 47.5 50.575L52.5 5H7.5Z"
      fill="black"
    />
  </svg>
</template>
